import { useMutation } from "@tanstack/react-query";
import { EndPoints } from "../../../Constants/endpoints";
import { GeneralResponse } from "../../../interface/GeneralResponse";
import Api from "../../generalApi/Api";
import { Methods } from "../../../Constants/ApiConstants";

export interface SendCodeViaWhatsAppRequest {
  Id: number;
  Channel?:string
}

export const useSendCodeViaWhatsApp = () => {
  const mutation = useMutation({
    mutationFn: (
      data: SendCodeViaWhatsAppRequest,
    ): Promise<GeneralResponse> => {
      return Api<SendCodeViaWhatsAppRequest, GeneralResponse>({
        method: Methods.POST,
        endpoint: EndPoints.ForgetPasswordSendCodeSMS, // Ensure this endpoint exists
        body: data,
      });
    },
    onSuccess: (data) => {
      return data;
    }
  });

  return mutation;
};
